<script>
    export default {
        inserted: function (el) {
                let current = 0;

            document.addEventListener("renderIncludedProductPagination",()=>{
                let controls = el.querySelectorAll("li[data-type='step']");
                let prev = el.querySelector("li[data-type='prev']");
                let next = el.querySelector("li[data-type='next']");
                var Zwiflocref = document.getElementById('zc1');
                var ZwiflocLengthbyId = parseInt(document.getElementById('zwilocLen').innerHTML);
                var totalZwiflocIncItems = ZwiflocLengthbyId;
                
                let pause = false;
                let rows = el.querySelectorAll('.zwifloc-row');
                

                let setOnClick = function (element, index) {
                    var clickZwiflocCounter = (current) * 6 ;

                    var toZwifloc = clickZwiflocCounter + 6;
                    if(toZwifloc >= totalZwiflocIncItems){
                        toZwifloc = totalZwiflocIncItems;
                    }

                    if((clickZwiflocCounter+1) <= totalZwiflocIncItems){
                        var clickZwElement = 'PRODUCTS ( ' + (clickZwiflocCounter + 1) + ' - ' + toZwifloc + ' OF ' + totalZwiflocIncItems + ' )';
                        Zwiflocref.innerHTML = clickZwElement;
                    }
                    element.onclick = function (e) {
                        pause = true;
                        for (let i = 0; i < controls.length; i++) {
                            controls[i].classList.remove('active');
                            rows[i].style.display = 'none';
                        }

                        for (let i = 0; i < controls.length; i++) {
                            if (i === index) {
                                current = index;
                                controls[i].classList.add('active');
                                rows[i].style.display = 'flex';
                            }
                        }
                    }
                }
                
                for (let i = 0; i < controls.length; i++) {
                    setOnClick(controls[i], i);
                }

                next.onclick = function () {
                    var nextZwiflocCounter = (current+1) * 6 ;

                    var toClickZwifloc = nextZwiflocCounter + 6;
                    if(toClickZwifloc >= totalZwiflocIncItems){
                        toClickZwifloc = totalZwiflocIncItems;
                    }

                    if((nextZwiflocCounter+1) <= totalZwiflocIncItems){
                        var nextZwElement = 'PRODUCTS ( ' + (nextZwiflocCounter + 1) + ' - ' + toClickZwifloc + ' OF ' + totalZwiflocIncItems + ' )';
                        Zwiflocref.innerHTML = nextZwElement;
                    }
                    pause = true;
                    slideTo(current + 1);
                }

                prev.onclick = function () {
                    pause = true;
                    if(current == 0){
                        current = 1;
                    }
                    var prevZwiflocCounter = (current-1) * 6 ;

                    var toPrevZwifloc = prevZwiflocCounter + 6;
                    if(toPrevZwifloc >= totalZwiflocIncItems){
                        toPrevZwifloc = totalZwiflocIncItems;
                    }

                    var prevZwElement = 'PRODUCTS ( ' + (prevZwiflocCounter + 1) + ' - ' + toPrevZwifloc + ' OF ' + totalZwiflocIncItems + ' )';
                    Zwiflocref.innerHTML = prevZwElement;
                    slideTo(current - 1);
                }

                let slideTo = function (index) {

                    if ((index >= 0) && (index < controls.length)) {
                        for (let i = 0; i < controls.length; i++) {
                            controls[i].classList.remove('active');
                            rows[i].style.display = 'none';
                        }

                        for (let i = 0; i < controls.length; i++) {
                            if (i === index) {
                                current = index;
                                controls[i].classList.add('active');
                                rows[i].style.display = 'flex';
                            }
                        }
                    }

                }

                setInterval(function () {
                    if ((current + 1) < controls.length) {
                        if (!pause) {
                            slideTo(current + 1);
                        }
                    } else {
                        if (!pause) {
                            slideTo(0);
                        }
                    }
                }, 100000);
            });
            
        }
    }

</script>
